import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import Icon from "../Icon";
import Spinner from "../Spinner";
import { Text } from "../Text";

function mapAlignToFlex(align) {
  if (align === 'start') {
    return 'flex-start';
  }

  if (align === 'end') {
    return 'flex-end';
  }

  return 'center';
}

var ContentState = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ContentState, _React$PureComponent);

  var _super = _createSuper(ContentState);

  function ContentState() {
    _classCallCheck(this, ContentState);

    return _super.apply(this, arguments);
  }

  _createClass(ContentState, [{
    key: "renderIcon",
    value: function renderIcon() {
      var _this$props = this.props,
          icon = _this$props.icon,
          scope = _this$props.scope,
          spinnerDelay = _this$props.spinnerDelay;
      var spinnerPadding = {
        bottom: 32,
        top: 20
      };

      if (scope === 'section') {
        spinnerPadding = {
          bottom: 12
        };
      } else if (scope === 'subsection') {
        spinnerPadding = {
          right: 8,
          vertical: 4
        };
      }

      var spinnerSize = scope === 'subsection' ? 'small' : 'large';
      var iconPadding = {
        bottom: 16
      };

      if (scope === 'section') {
        iconPadding = {
          bottom: 12
        };
      } else if (scope === 'subsection') {
        iconPadding = {
          right: 8
        };
      }

      var iconSize = 64;

      if (scope === 'section') {
        iconSize = 32;
      } else if (scope === 'subsection') {
        iconSize = 12;
      }

      if (!icon) {
        return null;
      } else if (icon === 'loading') {
        var delayProp = spinnerDelay == null ? {} : {
          delay: spinnerDelay
        };
        return /*#__PURE__*/React.createElement(Box, {
          margin: scope === 'page' ? {
            top: 4
          } : null,
          padding: spinnerPadding
        }, /*#__PURE__*/React.createElement(Spinner, _extends({
          flex: true,
          size: spinnerSize
        }, delayProp)));
      } else {
        return /*#__PURE__*/React.createElement(Box, {
          padding: iconPadding
        }, /*#__PURE__*/React.createElement(Icon, {
          color: "gray",
          icon: icon,
          size: iconSize
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          actions = _this$props2.actions,
          className = _this$props2.className,
          description = _this$props2.description,
          icon = _this$props2.icon,
          padding = _this$props2.padding,
          scope = _this$props2.scope,
          title = _this$props2.title,
          spinnerDelay = _this$props2.spinnerDelay,
          remaining = _objectWithoutProperties(_this$props2, ["actions", "className", "description", "icon", "padding", "scope", "title", "spinnerDelay"]);

      if (spinnerDelay != null && icon !== 'loading') {
        throw Error('You can only pass a spinner delay to a loading content state.');
      }

      var classes = classNames('ContentState', className);
      var paddingValue = null;

      if (scope === 'subsection') {
        paddingValue = {
          horizontal: 20,
          vertical: 12
        };
      } else if (scope === 'page') {
        paddingValue = {
          all: 48
        };
      } else {
        paddingValue = {
          horizontal: 20,
          vertical: 48
        };
      }

      var directionValue = scope === 'subsection' ? 'row' : 'column';
      var descriptionPadding = scope === 'subsection' ? {
        left: 8
      } : null;
      var alignItems = mapAlignToFlex(scope === 'subsection' ? 'center' : remaining.align);
      var justifyContent = mapAlignToFlex(scope === 'subsection' ? remaining.align : 'center');
      var actionsPadding = {
        top: 16
      };

      if (scope === 'section') {
        actionsPadding = {
          top: 12
        };
      } else if (scope === 'subsection') {
        actionsPadding = {
          left: 8
        };
      }

      return /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
        className: classes,
        flex: {
          alignItems: alignItems,
          justifyContent: justifyContent,
          direction: directionValue,
          wrap: 'wrap'
        },
        padding: padding !== undefined ? padding : paddingValue
      }), this.renderIcon(), title && /*#__PURE__*/React.createElement(Text, {
        className: "ContentState-title",
        align: "center",
        color: "gray",
        lineHeight: scope === 'page' ? 24 : 20,
        size: scope === 'page' ? 16 : 14,
        weight: icon === 'loading' || scope === 'subsection' ? 'regular' : 'medium'
      }, title), description && scope !== 'subsection' && /*#__PURE__*/React.createElement(Box, {
        padding: descriptionPadding
      }, /*#__PURE__*/React.createElement(Text, {
        align: "center",
        color: "gray",
        lineHeight: 20,
        size: 14
      }, description)), actions && scope !== 'subsection' && /*#__PURE__*/React.createElement(Box, {
        flex: {
          justifyContent: justifyContent
        },
        padding: actionsPadding
      }, actions));
    }
  }]);

  return ContentState;
}(React.PureComponent);

ContentState.defaultProps = {
  scope: 'page',
  align: 'center'
};
export default ContentState;